import React from 'react'

import { BACKEND_IP } from '../../utils/const'
import { clearSuffix, numSpaces } from '../../utils/functions'

import './CatCardMarket.scss'

export const CatCardMarket = ({ data, onClick }) => {
  const { tokenId, rank, traits } = data
  
  const traitsList = []
  for (const key in traits) {
    traitsList.push(
      <span key={ key }>
        { clearSuffix(traits[key], 'CoolCat') }
      </span>
    )
  }

  return (
    <button
      className="cat-card-market"
      onClick={ onClick }
    >
      <div className="img-container">
        <img
          src={`${ BACKEND_IP }/img/${ tokenId }.jpg`}
          alt="cat"
        />
      </div>
      <div className="desc">
        <span className="title">
          TRONCOOLCATS NFT # { tokenId }
        </span>
        <div className="props">
          <span>
            RANK <b>#{ rank }</b>
          </span>
          { traitsList }
        </div>
      </div>
      {
        data.lotPrice > 0
        && (
          <div className="price">
            <span className="trx">
              { numSpaces(data.lotPrice / 1000000) } TRX
            </span>
            {
              data.maxBid > 0
              && (
                <span className="bid">
                  { numSpaces(data.maxBid / 1000000) } BID
                </span>
              )
            }
          </div>
        )
      }
    </button>
  )
}